<div class="min-h-screen dark:bg-slate-900 p-4 md:p-8 text-sm text-slate-600 dark:text-slate-300">
  <div class="mb-8">
    <h1 class="text-3xl font-extrabold text-slate-800 dark:text-slate-100">Stamp Receipt</h1>
    <p class="text-slate-500 mt-2">ใบเสร็จแสตมป์ · path_id 85</p>
  </div>
  <div class="rounded-2xl border border-amber-200 bg-amber-50 dark:bg-amber-900/20 dark:border-amber-800 p-6 flex gap-4 items-start">
    <span class="material-icons text-amber-500">info</span>
    <div>
      <p class="font-bold text-amber-800 dark:text-amber-300">API endpoint ยังไม่พร้อม</p>
      <p class="text-amber-700 dark:text-amber-400 mt-1 text-sm">
        <code>GET /StampDiscount/getStampReceipt*</code> ยังไม่มีใน backend — หน้านี้เป็น stub รอ API
      </p>
    </div>
  </div>
</div>
